// eslint-disable-next-line no-shadow
export enum OnboardingModuleStatuses {
  INACTIVE = 1,
  ACTIVE = 2,
  COMPLETED = 3,
}
